import React from 'react';
import styles from './acceptCookiesBottom.css';

/***********************************************************************************************************************
 *
 * @type {React.NamedExoticComponent<{toggleCookies?: *, showAcceptCookiesModal?: *, content?: *, button_style?: *}>}
 **********************************************************************************************************************/

const AcceptCookiesBottom = React.memo ( ( { toggleCookies, showAcceptCookiesModal, button_style, content } ) => {
    return (
        <div className={ styles.wrapper }>
            <span className={ styles.title }>{ content.cookie_policy }</span>
            <span> { content.quiz_uses_cookies }
                {/*{ content.read_more } <a target='_blank' href='https://millionmind.com/terms/'>{ content.here }</a>*/}
            </span>
            <div className={ styles.buttonsGroup }>
                <button style={ button_style }
                    aria-label={ content.accept_cookies_aria_label }
                    onClick={ () => toggleCookies ( true ) }
                >
                    { content.accept_cookies }
                </button>
                <button style={ {
                    borderRadius: button_style?.borderRadius,
                    background: 'transparent',
                    border: '2px solid #fff'
                } }
                        onClick={ () => {
                            toggleCookies ( false );
                            showAcceptCookiesModal ();
                        } }
                    aria-label={ content.refuse_cookies_aria_label }
                >
                    { content.refuse_cookies }
                </button>
            </div>

        </div>
    );
} );

export default AcceptCookiesBottom;